



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../../services/animations';
import { ApiService } from '../../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, DialogType } from '../../../services/alert.service';
import { CreateEditContractTemplateModalComponent } from './create-edit-contract-template-modal/create-edit-contract-template-modal.component';
import { Router } from '@angular/router';
import { Service } from '../../../models/service.model';
import { ContractTemplate } from '../../../models/contract-template.model';

@Component({
    selector: 'contract-templates',
    template: require('./contract-templates.component.html'),
    styles: [require('./contract-templates.component.css')],
    animations: [fadeInOut]
})
export class ContractTemplatesComponent {
    contractTemplates: ContractTemplate[];
    constructor(private router: Router, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService) {
        this.getContractTemplates();
    }

    getContractTemplates() {
        this.apiService.getContractTemplates().subscribe(r => {
            this.contractTemplates = r;
        })
    }

    createEditContractTemplate(contractTemplate: any) {
        let dialogRef = this.dialog.open(CreateEditContractTemplateModalComponent, {
            width: '600px',
            data: {
                currentContractTemplate: contractTemplate || {},
                //vendors: this.ContractTemplates
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getContractTemplates();
        })
    }

    deleteContractTemplate(contractTemplateId: number) {
        this.alertService.showDialog("Do you want to delete this contractTemplate ?", DialogType.confirm, val => {

            this.apiService.deleteContractTemplate(contractTemplateId).subscribe(r => {
                this.getContractTemplates();
            });
        });
    }

    onActivate(event) {
        if (event.type === 'click') {
            this.router.navigate(['/contractTemplates/' + event.row.contractTemplateId]);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-settings/contract-templates/contract-templates.component.ts